<template>
  <CHeader with-subheader class="">
    <CHeaderNav
      class="d-lg-none bg-main w-100 d-flex align-items-center position-relative"
    >
      <div class="d-flex align-items-center nav-icon-container">
        <b-button
          variant="link"
          class="d-lg-none text-sub"
          @click="$store.commit('toggleSidebarCustom')"
        >
          <font-awesome-icon icon="bars" size="lg" />
        </b-button>
        <div class="d-none d-md-block d-lg-block d-xl-block ms-2">
          <CBreadcrumbRouter class="my-1 border-0" />
        </div>
      </div>

      <div class="logo-nav mx-auto">
        <!--  -->
        <div
          class="logo-home-page-desktop"
          v-bind:style="{
            'background-image': 'url(' + $store.state.config.logoHomePage + ')',
          }"
        >
          <!-- <img :src="'https://api-hourglass-booth-dev.dosetech.co/Upload/242803012800173.png'" alt="" class="w-100 h-auto" /> -->
        </div>
      </div>
    </CHeaderNav>
    <b-nav class="d-none d-lg-flex nav-customs pl-2">
      <b-nav-item target="_blank" to="/">
        <div
          class="logo-home-page-desktop"
          v-bind:style="{
            'background-image': 'url(' + $store.state.config.logoHomePage + ')',
          }"
        >
          <!-- <img :src="'https://api-hourglass-booth-dev.dosetech.co/Upload/242803012800173.png'" alt="" class="w-100 h-auto" /> -->
        </div>
      </b-nav-item>
      <b-nav-item to="/home">หน้าแรก</b-nav-item>
      <b-nav-item-dropdown
        v-if="permission.includes(1)"
        text="ลูกค้า"
        :toggle-class="[
          'nav-link-custom',
          { active: activeUrl == '/customer' },
        ]"
        left
      >
        <b-dropdown-item target="_blank" to="/customer/purchase-history"
          >กลุ่มลูกค้าที่มียอดซื้อ</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/customer/prospect"
          >กลุ่มลูกค้าที่ไม่มียอดซื้อ</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/customer/privileged"
          >กลุ่มลูกค้าที่ได้รับสิทธิพิเศษ</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <!-- <b-nav-item v-if="isSpa == 'true'" target="_blank" to="/spa">สปา</b-nav-item> -->
      <b-nav-item @click="register" v-if="permission.includes(2)"
        >ลงทะเบียน</b-nav-item
      >
      <b-nav-item
        @click="changeTime"
        v-if="allowTimeChange == 'true' && isFullPos == 0"
        >ปรับเวลา</b-nav-item
      >
      <b-nav-item target="_blank" to="/summary">สรุปยอด</b-nav-item>
      <b-nav-item
        target="_blank"
        to="/transaction"
        v-if="permission.includes(3)"
        >บิล
      </b-nav-item>

      <b-nav-item-dropdown
        target="_blank"
        text="รายการตั้งยอด"
        v-if="permission.includes(7) && $setting.is_consignment"
      >
        <b-dropdown-item target="_blank" to="/invoice-consignment"
          >Invoice - ตั้งยอด</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/cn-consignment"
          >CN - ลดหนี้ตั้งยอด</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/gp-consignment"
          >Tax - ส่งห้างประจำวัน</b-dropdown-item
        >
      </b-nav-item-dropdown>

      <b-nav-item-dropdown
        v-if="permission.includes(4)"
        text="รางวัล"
        :toggle-class="['nav-link-custom', { active: activeUrl == '/redeem' }]"
        left
      >
        <b-dropdown-item target="_blank" to="/redeem"
          >แลกคะแนนสะสม</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/mission"
          >Membership Activity</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        v-if="permission.includes(5)"
        text="รายงาน"
        :toggle-class="['nav-link-custom', { active: activeUrl == '/report' }]"
        left
      >
        <b-dropdown-item target="_blank" to="/report/point-balance"
          >เช็คคะแนน</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/report/ref-sale-member"
          >ประวัติการซื้อ</b-dropdown-item
        >
        <b-dropdown-item
          v-if="isSpa == 'true'"
          target="_blank"
          to="/report/spa-usage-history"
          >ประวัติการใช้</b-dropdown-item
        >
        <b-dropdown-item
          v-if="isSpa == 'true'"
          target="_blank"
          to="/report/outstanding"
          >Outstanding</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/report/history-sale-category"
          >ประวัติการซื้อแบ่งตามประเภทสินค้า</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item to="/product" v-if="permission.includes(9)"
        >สินค้า</b-nav-item
      >
      <b-nav-item-dropdown
        v-if="showInventory && permission.includes(6)"
        text="จัดการสินค้า"
        :toggle-class="[
          'nav-link-custom',
          { active: activeUrl == '/inventory' },
        ]"
        left
      >
        <b-dropdown-item target="_blank" to="/inventory"
          >จัดการสินค้า</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/deposit"
          >สินค้ามัดจำ</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/request-purchase"
          >สั่งผลิตสินค้าเพื่อเติมสต็อก</b-dropdown-item
        >

        <b-dropdown
          id="dropdown-2"
          text="โอนย้ายสินค้า"
          class="sub-dropdown"
          dropright
          variant="sub-dropdown"
        >
          <template v-for="items of inventoryList">
            <b-dropdown-item
              class="submenu"
              target="_blank"
              :to="
                '/inventory-transfer/' +
                items.id +
                `?doc=${items.code} - ${items.name}`
              "
              :key="items.id"
            >
              {{ items.code }}-{{ items.name }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
        <b-dropdown-item target="_blank" to="/repair-product"
          >รับซ่อม</b-dropdown-item
        >
        <b-dropdown-item target="_blank" to="/buy-back"
          >ซื้อคืนสินค้า</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item
        target="_blank"
        to="/inventory-check"
        v-if="permission.includes(8)"
        >นับสต๊อก</b-nav-item
      >
    </b-nav>
    <b-nav
      class="d-none d-lg-flex nav-customs justify-content-center align-items-center text-right ml-auto pr-2"
    >
      <div class="mr-2">
        <p>Store : {{ accountName }}</p>
        <p>
          {{ $moment(timestamp).format("DD/MM/YYYY HH:mm:ss") }}
          {{ plantId }}
        </p>
      </div>
      <div class="icon-power-off" @click="$refs.modalLogout.handleLogout()">
        <font-awesome-icon icon="power-off" title="logout" />
      </div>
    </b-nav>
    <ModalLogout ref="modalLogout" />
    <ModalRegister ref="modalRegister" :branchId="branchId" />
    <ModalChangeTime ref="modalChangeTime" :branchId="branchId" />
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import ModalLogout from "@/components/modal/alert/ModalLogout.vue";
import ModalRegister from "@/components/customer/ModalRegister.vue";
import ModalChangeTime from "@/components/modal/ModalChangeTime.vue";
import { mapGetters } from "vuex";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    ModalLogout,
    ModalRegister,
    ModalChangeTime,
  },
  data() {
    return {
      displayName: "",
      name: "",
      modalMessage: "Are you sure you want to log out ?",
      timestamp: "",
      totalTransactionError: 0,
      activeUrl: "/",
      myInterval: null,
      inventoryList: [],
      isDropdown2Visible: false,
    };
  },

  created: async function () {
    if (this.$route.meta.isChildren)
      this.activeUrl = this.$route.meta.activeUrl;
    this.myInterval = setInterval(this.getNow, 1000);
    this.getInventoryList();
    // await this.getTotalTransactionError();
    // setTimeout(() => {
    //   this.handleActiveMenuChild(this.$route.meta);
    // }, 0);
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      // console.log(bvEvent);
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      // console.log("object", bvEvent);
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
  computed: {
    ...mapGetters({
      accountName: "getAccountName",
      branchId: "getBranchId",
      plantId: "getPlantId",
      isSpa: "getSpa",
      allowTimeChange: "getAllowTimeChange",
      isFullPos: "getIsFullPos",
      showInventory: "getShowInventory",
      dateTimeFix: "getDateTimeFix",
      permission: "getRolePermission",
      $setting: "getBranchSetting",
    }),
  },
  watch: {
    "$route.meta"(newValue, oldValue) {
      if (newValue.isChildren) this.activeUrl = newValue.activeUrl;
      // this.handleActiveMenu(newValue, oldValue);
    },
    dateTimeFix(newValue, oldValue) {
      if (newValue != oldValue) {
        clearInterval(this.myInterval);
        this.timestamp = this.$moment(newValue).add(543, "years");
      }
    },
  },
  methods: {
    async getInventoryList() {
      const res = await this.axios(`${this.$baseUrl}/Inventory/Document/List`);
      this.inventoryList = res.detail;
    },
    async getTotalTransactionError() {
      this.axios
        .get(`${this.$baseUrl}/transactionerror/total/${this.branchId}`)
        .then((data) => {
          this.totalTransactionError = data.count;
        });
    },
    getNow: function () {
      this.timestamp = this.$moment().add(543, "years");
    },
    // clickChangeBrand(brand) {
    //   window.location.href = `/batch?brandID=${brand.id}`;
    // },
    handleActiveMenu: async function (newValue, oldValue) {
      if (newValue.activeUrl != oldValue.activeUrl) {
        await this.handleRemoveActiveMenuChild(oldValue);
      }
      await this.handleActiveMenuChild(newValue);
    },
    handleActiveMenuChild: async function (meta) {
      // .ps__rail-y
      var ele = await this.getAllElementsWithAttribute(
        "a",
        "href",
        `${meta.activeUrl}`
      );
      var parentElement = ele.parentElement.parentElement.parentElement;

      if (parentElement && parentElement.className == "c-sidebar-nav-dropdown")
        parentElement.setAttribute("class", "c-sidebar-nav-dropdown c-show");

      if (meta.lv == 1 && ele.className == "c-sidebar-nav-dropdown")
        ele.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      else if (
        meta.lv == 3 &&
        parentElement.parentElement.parentElement.className ==
          "c-sidebar-nav-dropdown"
      )
        parentElement.parentElement.parentElement.setAttribute(
          "class",
          "c-sidebar-nav-dropdown c-show"
        );

      if (meta.isChildren && ele.className == "c-sidebar-nav-link")
        await ele.setAttribute(
          "class",
          "router-link-exact-active c-active c-sidebar-nav-link"
        );

      setTimeout(() => {
        var div = document.getElementsByClassName("ps__rail-y")[0];
        div.style.top = `${ele.getBoundingClientRect().top}px`;
        ele.focus();
      }, 500);
      this.routeMeta = meta;
    },
    handleRemoveActiveMenuChild: async function (oldMeta) {
      var oldEle = this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      var parentElement = oldEle.parentElement.parentElement.parentElement;

      if (
        parentElement &&
        parentElement.className == "c-sidebar-nav-dropdown c-show"
      )
        parentElement.setAttribute("class", "c-sidebar-nav-dropdown");

      if (
        oldMeta.lv == 1 &&
        oldEle.className == "c-sidebar-nav-dropdown c-show"
      )
        oldEle.setAttribute("class", "c-sidebar-nav-dropdown");
      else if (
        oldMeta.lv == 3 &&
        parentElement.parentElement.parentElement.className ==
          "c-sidebar-nav-dropdown c-show"
      )
        parentElement.parentElement.parentElement.setAttribute(
          "class",
          "c-sidebar-nav-dropdown"
        );

      if (
        oldMeta.isChildren &&
        oldEle.className ==
          "router-link-exact-active c-active c-sidebar-nav-link"
      )
        await oldEle.setAttribute("class", "c-sidebar-nav-link");
    },
    getAllElementsWithAttribute(tagName, attribute, val) {
      var allElements = Array.from(document.getElementsByTagName(tagName));
      var filtered = allElements.filter((ele) => {
        return (
          ele.getAttribute(attribute) !== null &&
          ele.getAttribute(attribute) == val
        );
      });

      if (filtered.length) return filtered[0];
      else return false;
    },
    register() {
      this.$refs.modalRegister.show();
    },
    changeTime() {
      this.$refs.modalChangeTime.show();
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-home-page-desktop {
  min-height: 46px !important;
  min-width: 46px !important;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: auto;
  height: 100%;
  aspect-ratio: 16 / 9;
}

::v-deep .dropdown-menu.show {
  padding: 0 !important;
}

::v-deep .nav-customs {
  font-weight: bold;
  height: 46px;
  li.nav-item:first-child {
    .nav-link {
      padding: 0px !important;
      border: 0 !important;
      margin-right: 5px;
    }
  }
  li.nav-item {
    .nav-link,
    .nav-link.nav-link-custom {
      padding: 10px 10px !important;
      color: #000000;
      border-top: 3px solid white;
      border-bottom: 3px solid white;
      margin-right: 5px;
      font-size: 14px;
      height: 46px !important;
      span {
        color: #000000;
      }
    }
    .nav-link:hover,
    .nav-link.active {
      border-color: var(--primary-color);
    }
  }
}
.icon-power-off {
  cursor: pointer;
  text-align: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px none #fff;
  background: linear-gradient(
    -90deg,
    var(--secondary-color) 50%,
    var(--primary-color) 50%
  );
  svg {
    color: white;
    font-size: 26px;
    margin: 6px;
  }
}

::v-deep .breadcrumb-item {
  span {
    color: var(--font-primary-color);
  }
}

@media (min-width: 992px) {
  .c-header {
    .dropdown-menu {
      padding: 0 !important;
    }
    ul:last-child {
      p {
        margin-bottom: 0;
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
  .c-header {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: white !important;
    border: 0 !important;
    min-height: 46px;
    color: #000000;
    font-size: 14px;
  }
}

@media (max-width: 1200px) {
  ::v-deep .nav-customs {
    font-size: 12px;
    li.nav-item {
      .nav-link,
      .nav-link.nav-link-custom {
        font-size: 12px;
      }
    }
  }
}

::v-deep .btn:not(:disabled):not(.disabled) svg {
  color: var(--primary-color);
}

.nav-icon-container {
  position: absolute;
  left: 0;
}
.sub-dropdown {
  width: 100%;
}
::v-deep .sub-dropdown > button.btn-sub-dropdown {
  background-color: white;
  display: flex;
  color: #333333;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1.25rem;
}
</style>
